<div class="d-flex align-items-center justify-content-center">
  @if (subscription?.isInCart) {
    <em
      class="fas fa-check-circle grid-icon in-cart"
      title="Added to Cart"
    ></em>
  } @else {
    @if (
      subscription?.status === esnSubscriptionStatus.Unregistered ||
      subscription?.status === esnSubscriptionStatus.Canceled ||
      subscription?.status === esnSubscriptionStatus.Expired
    ) {
      <kehe-phoenix-button
        [spinner]="
          (registerInProgress$ | async) &&
          (((isBulkAction | async) === false &&
            (registerRowID | async) === subscription?.esn) ||
            ((isBulkAction | async) && isSelected(subscription?.esn)))
        "
        [disabled]="
          (registerInProgress$ | async) &&
          (registerRowID | async) !== subscription?.esn
        "
        classAttr="btn-large btn-link"
        (click)="registerEsnSubscription(subscription)"
        title="Register"
      >
        @if (
          (registerInProgress$ | async) === false ||
          ((isBulkAction | async) === false &&
            (registerRowID | async) !== subscription?.esn) ||
          ((isBulkAction | async) && !isSelected(subscription?.esn))
        ) {
          <em class="fas fa-plus-circle"></em>
        }
      </kehe-phoenix-button>
    }
    @if (
      (subscription?.status === esnSubscriptionStatus.Registered ||
        subscription?.status === esnSubscriptionStatus.PendingRenewal ||
        subscription?.status === esnSubscriptionStatus.ExpiringSoon) &&
      !thirdPartyUsers
    ) {
      <kehe-phoenix-button
        classAttr="btn-large btn-link"
        (click)="cancelEsnSubscription(subscription)"
        title="Cancel Auto-Renew"
      >
        <em class="fas fa-minus-circle"></em>
      </kehe-phoenix-button>
    }
    @if (
      (subscription?.status === esnSubscriptionStatus.Registered ||
        subscription?.status === esnSubscriptionStatus.PendingRenewal ||
        subscription?.status === esnSubscriptionStatus.ExpiringSoon) &&
      thirdPartyUsers
    ) {
      <ng-container classAttr="btn-large btn-link" title="subscribed">
        <em class="fas fa-check-circle grid-icon in-cart"></em>
      </ng-container>
    }
  }
  <kehe-phoenix-button
    classAttr="btn-large btn-link"
    (click)="onManageRecipientsClick(subscription)"
    title="Manage Recipients"
    [disabled]="
      subscription?.status === esnSubscriptionStatus.Unregistered ||
      subscription?.status === esnSubscriptionStatus.Expired
    "
  >
    <em class="fas fa-users"></em>
  </kehe-phoenix-button>
</div>
